<template>
  <div class="footer">
      <div class="overAllBox">
        <div class="footer-top">
          <div class="footer-top-left">
            <div  class="footer-top-left-Title">NAVIGATION</div>
            <div class="footer-top-left-span"><span class="tspan" @click="swicthNav(0)"><router-link to="/" tag="span" >Home</router-link></span ><span ><router-link to="/" tag="span" >Download</router-link></span></div>
            <div class="footer-top-left-span"><span class="tspan" @click="swicthNav(1)"><router-link to="/about" tag="span" >About</router-link></span><span @click="swicthNav(5)"><router-link to="/contact" tag="span" >Contact</router-link></span></div>
            <div class="footer-top-left-span"><span class="tspan" @click="swicthNav(2)"><router-link to="/products" tag="span" >Products</router-link></span></div>
          </div>
          <div class="footer-top-right">
            <div class="footer-top-left-Title">NEWSLETTER</div>
            <div class="footer-top-right-span"> Subscribe to our newsletter</div>
            <div class="footer-input-Div">
              <div class="footer-input-Box">
                <input class="footer-input" placeholder="your email address" v-model="email"  onfocus="this.placeholder=''" onblur="this.placeholder='your email address'" type="text">
                <div class="footer-input-btn" @click="subData">SUBMIT</div>
              </div>
            </div>
          </div>

          <div class="header-right2">  
            <div style="height:3rem"></div>
              <!-- <div class="pr headerInput" v-if="search==true">
                    <input type="text" class="header-input" placeholder="product" v-model="keyword" @keyup.enter="searchlist()" onfocus="this.placeholder=''" onblur="this.placeholder='product'">
                    <i class="el-icon-close close"   @click="inputshowHide()"></i>
                </div>
                <img class="header-right-icon serchicon" src="../../../static/images/header_icon1.png" @click="inputshowHide()" alt=""> -->
                <img class="header-right-icon" style="width:1.8rem;height:2.4rem" src="../../../static/images/header_iconx2.png"  alt="">
                <img class="header-right-icon" style="width:2.0rem;height:2.0rem"  src="../../../static/images/header_iconx3.png"  alt="">
                <img class="header-right-icon" style="width:2.3rem;height:2.1rem" src="../../../static/images/header_iconx4.png"  alt="">
                <img class="header-right-icon" style="width:2.1rem;height:2.1rem" src="../../../static/images/header_iconx7.png"  alt="">
                <img class="header-right-icon" style="width:2.6rem;height:2.2rem" src="../../../static/images/header_iconx5.png"  alt="">
                <!-- <img class="header-right-icon" v-if="mute==false"  style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6.png" @click="muteSwitch()"  alt="">
                <img class="header-right-icon" v-else style="width:1.9rem;height:1.5rem" src="../../../static/images/header_icon6x.png" @click="muteSwitch()"  alt="">  -->
        </div>  


        </div>
        <div class="footer-bottom"> 
          <img class="footer-logo" src="../../../static/images/logo.png" alt="">
          <div class="footer-bottom-b">
            <div class="footer-bottom-text">Copyright@damons co. ltd</div>
            <div class="footer-bottom-text2" @click="myBingo">Made by bingo</div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
    name:'Footer',
    data(){
      return{
        email:'',
        search:false,
        mute:false,
        keyword:'',
      }
    },
    methods:{
      muteSwitch(){
        if(this.mute==false){
          this.mute=true
        }else{
          this.mute=false
        }
      },
     inputshowHide(){
        let inwidth=window.innerWidth
         this.keyword=''
        if(this.search==true){ //搜索框消失
          
          this.search=false 
        
           $('.serchicon').show() 
           if(inwidth<=414){//是ipad 移动端 控制小图标
             $('.header-right-icon').show() 
           }
        }else{ //搜索框出现
          this.search=true
           $('.serchicon').hide() 
           if(inwidth<=414){//是ipad 移动端 控制小图标
             $('.header-right-icon').hide() 
           }
        }
      },
      //搜索列表
      searchlist(){
          if(sessionStorage.getItem('header_current')==2){
            
             this.$router.push({ name: 'products', query: {keyword:this.keyword} });
             window.location.reload();
          }else{
            sessionStorage.setItem('header_current',2);
            this.$router.push({ name: 'products', query: {keyword:this.keyword} });
          }
      },
		swicthNav(index){
      // window.location.reload();
        sessionStorage.setItem('header_current',index);
       
    },
    myBingo(){
      window.open('http://123bingo.cn')
    },
		subData() {
			var that = this;
			if(that.email==''){
				that.$message({
					message: "Please fill in the Email",
					type: "warning"
				});
				return false
			}
			let data = {
				email: that.email,
			};
			that.$api.email(data).then(res => {
				if (res.status == 1) {
					that.$message({
						message: "Submit successfully",
						type: "success"
					});
				} else {
					that.$message({
						message: res.msg,
						type: "warning"
					});
				}
			});			
		},
    }
}
</script>
<style scoped>
 .footer{
     width: 100%;
     /* height: 34rem; */
     background-color: #577db2;;
     color: #ffffff;
		z-index: 1000;
		position: relative;
 }
 .footer-top{
   padding:4rem 0 3.8rem;
   border-bottom: 0.1rem solid #577db2;;
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
 }
 /* .footer-top-left{ */
   /* width: 18.8%; */
 /* } */
 .footer-top-left-Title{
   font-size: 1.8rem;
 }
 .footer-top-left-span{
   margin-top: 3.5rem;
 }
 .footer-top-left-span>span{
   margin-right: 8rem;
   color: #e6e6e6;
   font-size: 1.4rem;
   cursor: pointer;
   display: inline-block;
 }
  .tspan{
    width: 8.5rem;
  }
 .footer-top-right{
   text-align: right;
 }
 .footer-top-right-span{
   margin-top: 3.5rem;
   font-size: 1.4rem;
   color: #e6e6e6;
 }
 .footer-input-Div{
   display: inline-block;
   margin-top: 3rem;
 }
 .footer-input-Box{
   display: flex;
   align-items: center;
   width: 41rem;
   height: 3rem;
 }
 .footer-input{
   width: 100%;
   height: 3rem;
   outline: none;
   border: none;
   text-indent: 1.1rem;
   font-size: 1.4rem;
 }
 .footer-input-btn{
   height: 3rem;
   width: 10.2rem;
   line-height: 3rem;
   font-size: 1.4rem;
   color: #ffffff;
   text-align: center;
   background-color: #333333;
   cursor: pointer;
 }

 .footer-bottom{
   padding: 1.5rem 0 1.5rem;
   font-size: 1.4rem;
   color: #fff;
   text-align: right;
   display: flex;
   align-items: center;
   justify-content: space-between;
 }
 .footer-logo{
   /* width: 10.2rem; */
   height: 2.3rem;
 }
 .footer-bottom-b{
   display: flex;
 }
 .footer-bottom-text{
   margin-right: 1rem;
 }


 .header-right2{
   display: none;
   align-items: center;
   /* padding-top: 1rem; */
   /* padding-bottom: 1rem; */

 }
 .header-right-icon{
   width: 1.5rem;
   height: 1.5rem;
   margin-right: 2.8rem;
   cursor: pointer;
 }
 .headerInput{
   display: flex;
   align-items: center;
   background-color: #ffffff;
   padding:0  0.5rem;
   border-radius: 0.2rem;
   margin-right: 2.8rem;
   height: 3rem;
   width: 100%;
   transition: all .5s;
 }
 .header-input{
   width: 20rem;
   /* height:5rem; */
   padding: 0.2rem 0;
   font-size: 1.4rem;
   color: #4c4c4c;
   border: none;
   transition: all .5s;
 }
.close{
  
  color: #4c4c4c;
  cursor: pointer;
  font-size: 1.8rem;
}
 /*当浏览器尺寸等于320px时候的代码：手机端 */ 
@media screen   and (max-width:768px){
  .footer-top-left{
    display: none;
  }
    .footer-top-left-span>span{
      margin-right: 6rem;
      color: #e6e6e6;
      font-size: 1.4rem;
      cursor: pointer;
      display: inline-block;
    }
    .header-right2{
      display: flex;
      margin-top: 2rem;
      align-items: flex-end;
    }    
    .footer-top{
      flex-wrap: wrap;
    }
  .footer-top-right{
    margin-top: 0;
  }
}

 /*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:414px){
    .footer{
      overflow-x: hidden;
    }
    .footer-top{
      flex-wrap: wrap;
    }
    .footer-top-left{
      width: 100%;
    }
    .footer-top-right{
      width: 100%;
      text-align: left;
    }
    .footer-input-Div{
      width: 100%;
    }
    .footer-input-Box{
      width:97%;
    }
    .footer-top-left-span{
      margin-top: 2rem;
    }
    .footer-top-left-span>span{
      margin-right:5rem;
      color: #e6e6e6;
      font-size: 1.4rem;
      cursor: pointer;
      display: inline-block;
    }
    .footer-bottom-text{
      margin-right: 0.5rem;
    }

    
}
/*当浏览器尺寸等于768px时候的代码：手机端 */ 
@media screen  and  (max-width:414px){
    .footer-bottom{
      display: block;
      text-align: left;
    }
    .footer-logo{
      margin-bottom: 2rem;
    }
    .footer-bottom-text{
      margin-bottom: 1rem;
    }
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:375px){
    .footer-bottom-b{
      display: -webkit-box;
    }
    .footer-bottom-text{
      margin-right: 0.5rem;
      display: inline-block;
    }
    .footer-bottom{
      font-size: 1.2rem;
    }
    
   
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:320px){
    .footer-bottom-b{
      display: -webkit-box;
    }
    .footer-bottom-text{
      margin-right: 0.5rem;
      display: inline-block;
    }
    .footer-bottom{
      font-size: 1.0rem;
    }
    
   
}


/*当浏览器尺寸等于320px时候的代码：手机端 */ 
@media screen and (min-width:300px) and (max-width:320px){
    .footer-top-left-span>span{
      margin-right: 3rem;
      color: #e6e6e6;
      font-size: 1.4rem;
      cursor: pointer;
      display: inline-block;
    }
        
}

/*当浏览器尺寸等于375px时候的代码：手机端 */ 
@media screen and (min-width:360px) and (max-width:375px){
    .footer-top-left-span>span{
      margin-right: 5rem;
      color: #e6e6e6;
      font-size: 1.4rem;
      cursor: pointer;
      display: inline-block;
    }
        
}

/*当浏览器尺寸等于768px时候的代码：手机端 */ 
@media screen  and (min-width:766px) and  (max-width:768px){
    .footer-top-left-span>span{
      margin-right: 2rem;
      color: #e6e6e6;
      font-size: 1.4rem;
      cursor: pointer;
      display: inline-block;
    }
        
}






</style>